import { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router';

import { Box, Typography, Table, TableHead, TableRow, TableCell, TableBody, Paper, Chip } from '@mui/material';

import { ObtenerAudienciasPantalla } from '../../connections/comun/AgendaConnection';

import { PantallaAudienciaProps } from '../../interfaces/comun/AgendaInterface';

import { CircularProgressIndicator } from '../../components/CircularProgressIndicator';

import '../../css/Pantalla.css'

const toMinutes = ( hora: string ) => {

    const [h, m] = hora.split( ':' ).map( Number );

    return h * 60 + m;

};

const getFechaLocal = ( date: Date ) => {

    const y = date.getFullYear();
    const m = ( date.getMonth() + 1 ).toString().padStart( 2, '0' );
    const d = date.getDate().toString().padStart( 2, '0' );

    return `${y}-${m}-${d}`;
};

export const PantallaPage = () => {

    const { Id } = useParams();

    const rowRefs = useRef<(HTMLTableRowElement | null)[]>( [] );

    const [loading, setLoading] = useState( true );
    
    const [autoridad, setAutoridad] = useState( '' );  
    const [horaActual, setHoraActual] = useState( new Date() );

    const [audiencias, setAudiencias] = useState<PantallaAudienciaProps[]>( [] );

    const minutosActual = horaActual.getHours() * 60 + horaActual.getMinutes();

    const hora = horaActual.toLocaleTimeString('es-MX');

    const [fechaActual, setFechaActual] = useState(() => {

        const ahora = new Date();

        return { 
            fechaStr: getFechaLocal(ahora), 
            fechaDate: new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
        };

    });

    useEffect(() => {

        const timer = setInterval(() => {

            setHoraActual( new Date() );

        }, 1000);

        return () => clearInterval( timer );

    }, []);

    useEffect(() => {

        const timer = setInterval(() => {

            const ahora = new Date();

            const fechaStr = getFechaLocal( ahora );

            if ( fechaStr !== fechaActual.fechaStr ) {            

                setFechaActual({
                    fechaStr,
                    fechaDate: new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate())
                });

            }

        }, 1000);

        return () => clearInterval( timer );

    }, [ fechaActual ]);

    useEffect(() => {

        if ( audiencias.length !== 0 ) {

            const index = audiencias.findIndex( a => {

                const inicio = toMinutes( a.horaInicio );
                const fin = toMinutes( a.horaFin );

                if ( inicio <= fin ) {
                    return minutosActual >= inicio && minutosActual < fin;
                } 
                else {
                    return minutosActual >= inicio || minutosActual < fin;
                }

            });

            if ( index !== -1 ) {

                rowRefs.current[index]?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

            }

        }

    }, [ minutosActual, audiencias ]);

    useEffect(() => {

        async function Obtener() {

            setLoading( true );

            await ObtenerAudienciasPantalla( parseInt( Id ?? '0' ) ).then( resp => {
                    
                setTimeout(() => {
                    
                    const { success, autoridad, audiencias } = resp;
                    
                    if ( success ) {
    
                        setAutoridad( autoridad );
                        setAudiencias( audiencias );
    
                    }

                    setLoading( false );

                }, 700);

            });

        }

        Obtener();

    }, [ fechaActual, Id ]);

    return (
        <Box className="pantalla">

            {
                loading
                ?
                    <Box sx={{ textAlign: 'center', alignContent: 'center', height: '90vh' }}>
                        
                        <CircularProgressIndicator />

                    </Box>
                :
                    <Box sx={{ color: 'white', p: 4 }}>

                        <Box sx={{ textAlign: 'center', mb: 2 }}>

                            <Typography variant='h3' fontSize={ autoridad.length >= 60 ? 26 : 36 } fontWeight='bold'>
                                { autoridad }
                            </Typography>

                            <Typography variant='h5' mt={1} display={'none'}>
                                {
                                    fechaActual.fechaDate.toLocaleDateString('es-MX', {
                                        weekday: 'long',
                                        year: 'numeric',
                                        month: 'long',
                                        day: 'numeric'
                                    })
                                }
                            </Typography>

                            <Typography variant='h4' mt={1} display={'none'}>{ hora }</Typography>

                        </Box>

                        <Paper sx={{ height: '67vh', overflow: 'hidden', borderRadius: 3 }}>

                            <Table stickyHeader>

                                <TableHead>

                                    <TableRow>

                                        <TableCell sx={{ width: '20%', textAlign: 'center', fontSize: 20, fontWeight: 'bold', borderBottomColor: '#04123c', borderBottomWidth: 3 }}>
                                            Expediente
                                        </TableCell>

                                        <TableCell sx={{ width: '20%', textAlign: 'center', fontSize: 20, fontWeight: 'bold', borderBottomColor: '#04123c', borderBottomWidth: 3 }}>
                                            Sala
                                        </TableCell>

                                        <TableCell sx={{ width: '20%', textAlign: 'center', fontSize: 20, fontWeight: 'bold', borderBottomColor: '#04123c', borderBottomWidth: 3 }}>
                                            Tipo de audiencia
                                        </TableCell>

                                        <TableCell sx={{ width: '20%', textAlign: 'center', fontSize: 20, fontWeight: 'bold', borderBottomColor: '#04123c', borderBottomWidth: 3 }}>
                                            Hora
                                        </TableCell>

                                        <TableCell sx={{ width: '5%', borderBottomColor: '#04123c', borderBottomWidth: 3 }}> </TableCell>

                                    </TableRow>

                                </TableHead>

                                <TableBody>
                                    {
                                        audiencias.length === 0
                                        ? 
                                            <TableRow>

                                                <TableCell colSpan={5} sx={{ textAlign: 'center', border: 'none', py: 10 }}>

                                                    <Typography variant='h6' color='text.secondary'>
                                                        No se encontraron <br/> audiencias programadas
                                                    </Typography>

                                                </TableCell>

                                            </TableRow>
                                        : 
                                            audiencias.map( ( a, i ) => {

                                                const enCurso = (() => {

                                                    const inicio = toMinutes(a.horaInicio);
                                                    const fin = toMinutes(a.horaFin);
                                                
                                                    if ( inicio <= fin ) {
                                                        return minutosActual >= inicio && minutosActual < fin;
                                                    } 
                                                    else {
                                                        return minutosActual >= inicio || minutosActual < fin;
                                                    }

                                                })();

                                                return (

                                                    <TableRow
                                                        key={ i }
                                                        ref={ ( el: HTMLTableRowElement | null ) => {
                                                            if ( el ) rowRefs.current[i] = el;
                                                        }}
                                                        sx={{
                                                            backgroundColor: enCurso ? '#04123c' : 'white',
                                                            transition: 'background-color 1.8s ease',
                                                            scrollMarginTop: '16px', 
                                                        }}
                                                    >
                                                        <TableCell sx={{ color: enCurso ? 'white' : 'black', textAlign: 'center', borderBottomColor: enCurso ? '#04123c' : null }}>
                                                            <Typography variant={ enCurso ? 'h6' : 'body2' } fontSize={ enCurso ? 22 : 16 }>{ a.numeroExpediente }</Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ color: enCurso ? 'white' : 'black', textAlign: 'center', borderBottomColor: enCurso ? '#04123c' : null }}>
                                                            <Typography color={ enCurso ? 'warning' : 'primary' } variant='h6' fontSize={ enCurso ? 22 : 16 }>{ a.sala }</Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ color: enCurso ? 'white' : 'black', textAlign: 'center', borderBottomColor: enCurso ? '#04123c' : null }}>
                                                            <Typography variant={ enCurso ? 'h6' : 'body2' } fontSize={ enCurso ? 22 : 16 }>{ a.tipoAudiencia }</Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ color: enCurso ? 'white' : 'black', textAlign: 'center', borderBottomColor: enCurso ? '#04123c' : null }}>
                                                            <Typography variant={ enCurso ? 'h6' : 'body2' } fontSize={ enCurso ? 22 : 16 }>{ a.horaInicio } - { a.horaFin }</Typography>
                                                        </TableCell>

                                                        <TableCell sx={{ textAlign: 'center', borderBottomColor: enCurso ? '#04123c' : null }}>
                                                        
                                                            {
                                                                enCurso 
                                                                &&
                                                                    <Chip
                                                                        label={ <Typography variant='subtitle1' fontSize={14} fontWeight={600}>Audiencia en curso</Typography> }
                                                                        color='success'
                                                                    />
                                                            }
                                                        </TableCell>

                                                    </TableRow>

                                                );

                                            })
                                    }

                                </TableBody>

                            </Table>

                        </Paper>

                    </Box>
            }

        </Box>

    );
}